import styled from 'styled-components';
import { NavLink as RouterNavLink } from 'react-router-dom';

export const Container = styled.div`
  width: 248px;
  height: 100vh;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.grey.main};

  display: flex;
  flex-direction: column;
`;

export const LogoContainer = styled.div`
  img {
    width: 80px;
    height: 80px;
  }
  margin: ${({ theme }) => theme.sizes.padding.biggest};
`;

export const Line = styled.div`
  width: 40px;
  height: 2px;
  margin-left: -40px;
  border-radius: 0px 2px 2px 0px;
  background-color: ${({ theme }) => theme.colors.white.main};

  transition: margin-left 0.5s ease-in-out;
`;

export const NavLink = styled(RouterNavLink)`
  height: 56px;
  width: 100%;

  gap: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:active {
    gap: 16px;
    ${Line} {
      margin-left: 0px;
    }
  }

  &.active {
    gap: 16px;
    ${Line} {
      margin-left: 0px;
    }
  }

  transition: gap 0.5s ease-in-out;
`;
